import { Module, Factory } from './decorators';
import { Loader } from "@googlemaps/js-api-loader"
import { GOOGLE_API_KEY } from './constants';


@Module({
    name: 'app.helpers',
    modules: [],
})
@Factory('BlndHelpers', function($q) {
    "ngInject";
    return {
        all: function (promises) {
          var deferred = $q.defer();
          var results = _.fromPairs(_.map(promises, function(v, k){
              return [k, null];
          }));
          var callback = function(name){
              return function(resp){
                  var nulls;
                  results[name] = resp;
                  nulls = _.filter(results, function(v){ return v === null; });
                  if (nulls.length === 0) {
                      deferred.resolve(results);
                  }
              };
          };
          _.each(promises, function(v, k){
              v.then(callback(k), callback(k));
          });
          return deferred.promise;
      }
    };
})
export default class F {}

// Google Maps Api

export class MapClass {
    constructor(object) {
        this.object = object;
        this.markers = [];
        this.map = null;
        this.getStaticLocations();
        this.prepareMap();
    }

    getDynamicLocations(fields) {
        /*
        Returns chosen fields locations in editModal.
        */
        this.getLocations(fields)
    }

    getStaticLocations() {
        /*
        Returns object locations saved in db.
        */
        this.getLocations(this.object.fields)
    }

    getLocations(fields) {
        /*
        Creates locations list of dicts with parameters to compose map,
        markers and template for google maps.

        *loc - object's custom fields destinations if set, else location of
            fields destination

        If fields are not set or doesn't have location
        function returns geoLocation of Willardag Freederick
        */
        let self = this;
        let locations = []
        self.noMarkers = false
        fields.forEach((field, index) => {
            let geo = field.field.geo
            if (geo.latitude && geo.longitude && field.field.location) {
                // if object has custom geoLocations returns it instead of original
                let field_full_name = `${field.field.farm_name}: ${field.field.field_name} - ${field.field.acres}`
                if (field.field.id in self.object.custom_fields_destinations) {
                    let custom_loc = self.object.custom_fields_destinations[field.field.id]
                    locations.push({
                        loc: custom_loc,
                        field_id: field.field.id,
                        full_string: `${index+1}. (${custom_loc.lat}, ${custom_loc.lng}) [${field_full_name}]`
                    })
                } else {
                    locations.push({
                        loc: { lat: geo.latitude, lng: geo.longitude },
                        field_id: field.field.id,
                        full_string: `${index+1}. ${field.field.location} [${field_full_name}]`,
                    })
                }
            }
        })
        if (!locations.length) {
            self.noMarkers = true
            locations = [{
                loc: { lat: 39.411136, lng: -77.402671 },
                field_id: null,
                full_string: "",
            }]
        }
        self.varLocations = locations;
    }

    prepareMap() {
        let self = this;
        self.loader = new Loader({
            apiKey: GOOGLE_API_KEY,
            libraries: ["places"],
            version: "weekly",
        })
        self.loader.load().then(() => {
            self.map = new google.maps.Map(document.getElementById("map"), {
                zoom: 9,
                center: self.varLocations[0].loc,
            })
        })
    }
}

export class DetailViewMap extends MapClass {
    constructor(object) {
        super(object);
        this.updateMarkers();
    }

    updateMarkers() {
    let self = this;
        self.loader.load().then(() => {
            self.markers.forEach((marker) => {
                marker.setMap(null);
            })
            self.map.setCenter(self.varLocations[0].loc)
            if (!self.noMarkers) {
                self.varLocations.forEach((location) => {
                    var marker = new google.maps.Marker({
                        position: location.loc,
                        map: self.map,
                        label: {text: location.full_string, color: "white", className: "custom-marker"}
                    });
                    self.markers.push(marker)
                })
            }
        })
    }
}

export class EditViewMap extends MapClass {
    constructor(object) {
        super(object);
        this.updateMarkers();
    }

    updateMarkers() {
        let self = this;
        self.loader.load().then(() => {
            self.markers.forEach((marker) => {
                marker.setMap(null);
            })
            self.map.setCenter(self.varLocations[0].loc)
            if (!self.noMarkers) {
                self.varLocations.forEach((location) => {
                    var marker = new google.maps.Marker({
                        position: location.loc,
                        map: self.map,
                        draggable: true,
                        label: {text: location.full_string, color: "white", className: "custom-marker"}
                    });
                    marker.addListener("dragend", () => {
                        let latValue = marker.getPosition().lat().toFixed(6);
                        let lngValue = marker.getPosition().lng().toFixed(6);
                        self.object.custom_fields_destinations[location.field_id] = {
                            lat: parseFloat(latValue),
                            lng: parseFloat(lngValue),
                        }
                    })
                    self.markers.push(marker)
                })
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers.js